module.exports = __webpack_public_path__ + "static/ucetnictvi-73fa8b01870cf30939212452114b7d18.svg";